import 'leaflet';
import "leaflet-active-area";
import { LatLng } from 'leaflet';

const mapOptions = {
    zoomControl: false,
    minZoom: 11,
    // maxBounds: L.latLngBounds(corner1, corner2),
}

export class Map {
    constructor(selector, data, App) {
        this.App = App;
        this.LMAP = L.map(selector, mapOptions)
        .setView([48.2082, 16.3738], 13)
        .setActiveArea('activeArea', true, true)

        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/256/{z}/{x}/{y}@2x?access_token={accessToken}', {
            attribution: 'Data©<a href="https://www.openstreetmap.org/">OpenStreetMap</a>(<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>), Img©<a href="https://www.mapbox.com/">Mapbox</a>',
            maxZoom: 18,
            id: 'viennacontemporary/cks8pflmp8jyq18o4y70ci7t3',
            accessToken: 'pk.eyJ1Ijoidmllbm5hY29udGVtcG9yYXJ5IiwiYSI6ImNrczhsendmMzA0dGwyeHA0eTY1djkxbmQifQ.2pyqMGJNQn6xUfy1EwSxYg'
        }).addTo(this.LMAP);

        this.markers = [];
        this.categories = [];
        this.markerLayerGroups = [];
        this.data = data;

        this.init();
    }
    processData() {
        this.data.forEach((item) => {
            let i = this.categories.findIndex(x => x == item.category);
            if (i <= -1) {
                this.categories.push(item.category);
            }
        });
        if (this.App.state.isFiltered) return;
        this.App.setState({activeCategories: this.categories})
    }
    createMarker(data) {
        let marker = L.marker(new LatLng(data.lat, data.lng), {
            title: data.uid,
            icon: L.divIcon({
                className: `marker`,
                html: `
                    <a href="${data.thref[this.App.language]}">
                        <div class="marker-icon" style="--color:${data.color}"></div>
                        <span>${data.title}</span>
                    </a>
                `,
                iconSize: new L.Point(20, 20),
            }),
        });

        if (!this.App.state.popupOnly) return marker;

        marker.bindPopup(`
            <h1 class="location-title">${data.title}</h1>
            <address class="location-address">${data.address}</address>
            <div class="location-links">
                <a class="location-link" href="${data.navigationLink}" target="_blank">
                    <i class="las la-location-arrow"></i>
                    Navigate here
                </a>
                <br>
                <a class="location-link" data-no-swup href="${data.thref[this.App.language]}" target="_blank">
                    <i class="la la-info"></i>
                    More information
                </a>
            </div>
        `);

        return marker;
    }
    addMarkers() {
        this.categories.forEach(category => {
            let group = L.featureGroup();
            let data = this.data.filter(x => x.category == category);
            data.forEach(d => {
                let marker = this.createMarker(d);
                this.markers.push({
                    d,
                    marker,
                });
                group.addLayer(marker);
            })
            this.markerLayerGroups.push({
                name: category,
                group,
            });
            if (this.App.state.activeCategories.indexOf(category) > -1) group.addTo(this.LMAP);
        });
    }
    filterMarkers(category = '_all_') {
        this.markerLayerGroups.forEach(group => {
            if (category == '_all_') return this.LMAP.addLayer(group.group);

            if (group.name != category) {
                this.LMAP.removeLayer(group.group)
            } else {
                this.LMAP.addLayer(group.group)
            }
        })
    }
    setActiveMarker(marker = null) {
        this.markers.forEach(m => {
            if (m == marker) {
                m.marker._icon.classList.add('is-active');
                this.activeMarker = marker;
            } else {
                // check if marker is on map
                if (m.marker._icon) {
                    m.marker._icon.classList.remove('is-active');
                }
            }
        })
    }
    addListeners() {
        this.LMAP.on('click', e => {
            // if (e.target.)
            // console.log(e.target);
        })

        // center popup on map
        this.LMAP.on('popupopen', function(e) {
            let map = this;
            // document.body.classList.add('is-popup-open');
            var px = map.project(e.target._popup._latlng); // find the pixel location on the map where the popup anchor is
            px.y -= e.target._popup._container.clientHeight/2; // find the height of the popup container, divide by 2, subtract from the Y axis of marker location
            map.panTo(map.unproject(px),{animate: true}); // pan to new center
        });
    }
    getMarkerByLocationId(locationId) {
        return this.markers.find(m => m.d.id == locationId);
    }
    init() {
        this.processData();
        this.addMarkers();
        this.addListeners();
    }
}